// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"16":"d9317ee5","224":"554c07ee","360":"e133c9e5","397":"88d7387e","521":"6a4338aa","527":"071f313d"}[chunkId] + ".css";
};